import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Input } from 'components/fields'
import { form, modal } from 'helpers/decorators'
import { apiLogin } from 'helpers/decorators/api'
import validate from './mfa-code'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { Button } from 'components/misc'
import { FormattedMessage } from 'react-intl'
import { push } from 'connected-react-router'
import styles from './mfa-code.styl'

@apiLogin()
@modal.trigger()
@connect(
  ({ auth }) => ({
    user: auth.user,
    submitting: auth.loading
  }), {
    push
  }
)
@form({
  form: 'setMfaCode',
  disableHook: true,
  validate
})
class MfaCode extends Component {
  static propTypes = {
    user: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    onSetMfaCode: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    modal: PropTypes.func,
    push: PropTypes.func.isRequired
  }

  handleSubmit = fields => {
    const loginId = get(this.props, 'user.loginId')
    const code = get(fields, 'mfaCode')
    this.props.onSetMfaCode({ loginId, code })
  }

  render () {
    const { handleSubmit, submitting } = this.props

    return (

        <div className={styles.wrapper}>
          <form onSubmit={handleSubmit(fields => this.handleSubmit(fields))}>
          <div className="row">
            <div className="col-xs-4">
            </div>
            <Input
              name="mfaCode"
              label="Please insert 6 digits."
              intlKey="label.authenticator_app_code_desc"
              type={'number'}
            />
          </div>
          <div className="row">
          <Button
            {...this.props}
            isLoading={submitting}
            simple
            fluid
          >
            <FormattedMessage id="button.submit" defaultMessage="Submit" />
          </Button>
          </div>
          </form>
        </div>

    )
  }
}

export default MfaCode
